<template>
  <div style="background-color: #e8eef2">
    <PCNavbar selectIndex="2" />
    <MobileNavBar :currentActive="1" />

    <div class="data_brain_wrap">
      <el-row class="card_wrap" type="flex">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="工商业电价" name="first" style="padding-right: 20px">
            <div class="containt" style="display: flex;flex-direction: column;">
              <div style="display: flex;align-items:center;padding:10px">


                地区：
                <el-select v-model="form1.regionSelect" placeholder="请选择">
                  <el-option v-for="(item, index) in region" :key="index" :value="item">
                    {{ item }}
                  </el-option>
                </el-select>
                用电类型I
                <el-select v-model="form1.Type1lSelect" placeholder="请选择">
                  <el-option v-for="(item, index) in electricityType1" :key="index" :label="item.typeName"
                    :value="item.typeCode"></el-option>
                </el-select>
                用电类型II
                <el-select v-model="form1.Type2lSelect" placeholder="请选择">
                  <el-option v-for="(item, index) in electricityType2" :key="index" :label="item.typeName"
                    :value="item.typeCode"></el-option>
                </el-select>
                电压等级：
                <el-select v-model="form1.VoltageLevelSelect" placeholder="请选择">
                  <el-option v-for="(item, index) in ectricityVoltageLevel" :key="index" :value="item.levelCode"
                    :label="item.levelName"></el-option>
                </el-select>
              </div>
              <div>
                <RadioGroup v-model="form1.searchType" type="button">
                  <Radio label="分时电价"></Radio>
                  <Radio label="分月电价"></Radio>
                  <Radio label="峰谷价差"></Radio>
                </RadioGroup>
              </div>
              <div style="display: flex;align-items:center;padding:10px">
                月份选择：
                <el-select v-model="form1.selectYearMonth" placeholder="请选择" v-if="form1.searchType == '分时电价'"
                  style="width:300px">
                  <el-option v-for="(item, index) in yearMonthsArray" :key="index" :value="item"
                    :label="item"></el-option>
                </el-select>

                <el-date-picker v-else style="width:350px" v-model="form1.monthValue" type="monthrange"
                  range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" @change="getDateTime"
                  :picker-options="pickerOptions" value-format="yyyy-MM"></el-date-picker>
              </div>
              <div class="china-map" ref="hoursPrice"></div>
              <!-- <div class="china-map" ref="monthPrice"></div>
            <div class="china-map" ref="peakValleyPrice"></div> -->
            </div>
          </el-tab-pane>
          <el-tab-pane label="电价分析" name="second">
            <div>
              地区：
              <el-select v-model="form2.regionSelect2" placeholder="请选择">
                <el-option value="全国">全国</el-option>
                <el-option v-for="(item, index) in region" :key="index" :label="item"></el-option>
              </el-select>
              用电类型I
              <el-select v-model="form2.Type1lSelect2" placeholder="请选择">
                <el-option v-for="(item, index) in electricityType1" :key="index" :value="item.typeCode"
                  :label="item.typeName"></el-option>
              </el-select>

              电压等级：
              <el-select v-model="form2.VoltageLevelSelect2" placeholder="请选择">
                <el-option v-for="(item, index) in ectricityVoltageLevel" :key="index" :value="item.levelCode"
                  :label="item.levelName"></el-option>
              </el-select>
            </div>
            <div style="margin: 20px 0;">
              月份选择
              <el-select v-model="form2.selectYearMonth2" placeholder="请选择">
                <el-option v-for="(item, index) in yearMonthsArray" :key="index" :value="item"
                  :label="item"></el-option>
              </el-select>
            </div>
            <div>
              峰谷价差
              <el-select v-model="form2.selectFG" placeholder="请选择">
                <el-option value="高峰低谷">高峰低谷</el-option>
                <el-option value="高峰平时">高峰平时</el-option>
                <el-option value="最大价差">最大价差</el-option>
              </el-select>
            </div>
            <div class="china-map" ref="fenxi"></div>
          </el-tab-pane>
        </el-tabs>
      </el-row>
    </div>

    <div style="
        cursor: pointer;
        font-size: 2ch;
        position: fixed;
        right: 0;
        top: 50%;
        padding: 0.6vw 1vw;
        color: #fff;
        background: linear-gradient(to right, #792ee7, #04c0cd);
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
      ">
      在线客服
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";

import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";
import * as echarts from "echarts";
import {
  getRegion,
  getElectricityAnalysis,
  getElectricityBusiness,
  getElectricityVoltageLevel,
  getElectricityType,
} from "@/api/user.js";

export default {
  data() {
    return {
      activeName: "first",
      electricityType1: [],
      electricityType2: [],
      ectricityVoltageLevel: [],
      yearMonthsArray: [], // 月份数组
      form1: {
        regionSelect: "", // 地区选择
        VoltageLevelSelect: "", // 电压等级选择
        Type1lSelect: "two", // 用电类型I
        Type2lSelect: "industryAndCommerce", // 用电类型II
        selectYearMonth: "",
        searchType: "分时电价",
        monthValue: [],
      }, //表单
      form2: {
        regionSelect2: "全国", // tabe2地区选择
        VoltageLevelSelect2: "", //tab2 电压等级选择
        Type1lSelect2: "two", //tab2 用电类型I
        selectYearMonth2: "", //tab2
        selectFG: "最大价差", // tab2
      },
      region: [],

      key: 0,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.curDate = minDate.getTime();
        },
        disabledDate: (time) => {
          let currentD = new Date();
          if (this.curDate) {
            currentD = new Date(this.curDate);
          }
          let currMonth = currentD.getMonth() + 1;
          let afterMonth = currMonth - 1;
          let afterYear;
          if (afterMonth == 0) {
            afterMonth = 12;
            afterYear = currentD.getFullYear();
          } else {
            afterYear = currentD.getFullYear() + 1;
          }

          let beforeMonth = currMonth + 1;
          let beforeYear;
          if (beforeMonth == 13) {
            beforeMonth = 1;
            beforeYear = currentD.getFullYear();
          } else {
            beforeYear = currentD.getFullYear() - 1;
          }
          let currDate = currentD.getDate();
          let afterDate = new Date(
            afterYear + "-" + afterMonth + "-" + currDate
          );
          let beforeDate = new Date(
            beforeYear + "-" + beforeMonth + "-" + currDate
          );
          if (new Date() < afterDate) {
            afterDate = new Date();
          }
          return time.getTime() < beforeDate || time.getTime() > afterDate;
        },
      },
type1Grapy:{},
type2Grapy:{},
      isUse: [],
      address: [],
      publishAgency: [],
      state: [],
      keyword: "",
      expandedKeys: [],
      yearMonth: [],
      rightData: [],
      yearMonthFX: [],
      fxYearMonth: "",
      mapMaxcount: "",
      dataMap: [],
      datalevel: [],
      datatypeName: [],
      datatypeCount: [],
      myChart: null
    };
  },
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  watch: {
    form1: {
      handler: function (newVal, oldVal) {
        // console.log(
        //   "oldVal is: " + oldVal + " newVal is: " + JSON.stringify(newVal)
        // );
        if(this.activeName=='first'){
          let pramas = {};
        if (newVal.searchType == "分时电价") {
          pramas.searchType = "hoursPrice";
          pramas.region = newVal.regionSelect;
          pramas.voltageLevelCode = newVal.VoltageLevelSelect;
          pramas.electricityTypeCode1 = newVal.Type1lSelect;
          pramas.electricityTypeCode2 = 'type2';// newVal.Type2lSelect;
          pramas.yearMonth = newVal.selectYearMonth;
        }
        if (newVal.searchType == "分月电价") {
           pramas.searchType = "monthPrice";
           pramas.region = newVal.regionSelect;
           pramas.voltageLevelCode = newVal.VoltageLevelSelect;
           pramas.electricityTypeCode1 = newVal.Type1lSelect;
           pramas.electricityTypeCode2 = newVal.Type2lSelect;
           pramas.startYearMonth = newVal.monthValue[0];
           pramas.endYearMonth = newVal.monthValue[1];         
        }
        if (newVal.searchType == "峰谷价差") {
          pramas.searchType = "peakValleyPrice";
           pramas.region = newVal.regionSelect;
           pramas.voltageLevelCode = newVal.VoltageLevelSelect;
           pramas.electricityTypeCode1 = newVal.Type1lSelect;
           pramas.electricityTypeCode2 = newVal.Type2lSelect;
           pramas.startYearMonth = newVal.monthValue[0];
           pramas.endYearMonth = newVal.monthValue[1];
        }
        this.getElectricityBusiness(pramas);
        }
        
      },

      deep: true,
    },
    //  form1(newVal){
    //  console.log(" newVal is: " + newVal);
    // },
    form2: {
      handler: function (newVal, oldVal) {
        if (newVal &&  this.activeName=='second') {
          let params = {
            // region: newVal.regionSelect2,
            // voltageLevelCode: newVal.VoltageLevelSelect2,
            // electricityTypeCode1: newVal.Type1lSelect2,
            // yearMonth: newVal.selectYearMonth2,
            "region": "",
    "voltageLevelCode": "level1",
    "electricityTypeCode1": "two",
    "searchType": "maxSpread",
    "yearMonth": "2025-08"
          };
          if (newVal.selectFG == "最大价差") {
            params.searchType = "maxSpread";
          }
          if (newVal.selectFG == "高峰低谷") {
            params.searchType = "sharpValley";
          }
          if (newVal.selectFG == "高峰平时") {
            params.searchType = "sharpNormal";
          }
          this.getElectricityAnalysis(params);
        }

      },

      deep: true,
    },
  },
  mounted() { },
  created() {
    this.getElectricityVoltageLevel();
    this.getElectricityType();
    this.getRegion();
    this.generateYearMonthsArray();
  },
  methods: {
    getDateTime() {
      this.key += 1; // 时间选择后进行页面刷新
      let dateValues = this.form1.monthValue;
      let fromDate = dateValues[0];
      let toDate = dateValues[1];
    },
    /**
     * 生成前12个月的年月数组
     *
     * @returns 返回前12个月的年月数组，格式为"年-月"的字符串数组
     */
    generateYearMonthsArray() {
      let result = []; //先创建一个空数组，方便后面存储日期数据
      let d = new Date(); // 当前时间
      let year = d.getFullYear(); // 当前年份
      d.setMonth(d.getMonth() + 1, 1); //设置月份,设置当前日为1号 （避免出现31号时候，其他月份没有31号的bug）
      for (var i = 0; i < 12; i++) {
        //开始循环
        d.setMonth(d.getMonth() - 1); //月份值-1  循环的时候在当前月份上减一 来获取上个月的月份（0 ~ 11）
        var m = d.getMonth() + 1; // 月份 + 1 来获取真正的月份 （1 ~ 12）
        m = m < 10 ? "0" + m : m; //三元表达式来判断 如果小于10月 给前面 +0 如果大于等于10月 则不变输出
        result.push(d.getFullYear() + "-" + m); //将 循环出来的 年月 一次 存放进 result 数组中
      }
      console.log(result);
      this.yearMonthsArray = result;
      this.form1.selectYearMonth = this.form2.selectYearMonth2 = result[0];

      this.form1.monthValue.push(result[11]);
      this.form1.monthValue.push(result[0]);
      // return result.reverse(); // 返回反向排列的数组
    },

    // tab1Search() {
    //   this.getElectricityBusiness();
    // },
    tab2Search() {
      console.log('yab2')
      let params = {
        // region: this.form2.regionSelect2,
        // voltageLevelCode: this.form2.VoltageLevelSelect2,
        // electricityTypeCode1: this.form2.Type1lSelect2,
        // yearMonth: this.form2.selectYearMonth2,
          "region": "",
    "voltageLevelCode": "level1",
    "electricityTypeCode1": "two",
    "searchType": "maxSpread",
    "yearMonth": "2025-08"
      };
      if (this.form2.selectFG == "最大价差") {
        params.searchType = "maxSpread";
      }
      if (this.form2.selectFG == "高峰低谷") {
        params.searchType = "sharpValley";
      }
      if (this.form2.selectFG == "高峰平时") {
        params.searchType = "sharpNormal";
      }
      this.getElectricityAnalysis(params);
    },
    
    showfenxi(legend, xAxis, series,) {
      const chartDom = this.$refs.fenxi;

     if (this.myChart != null && this.myChart.dispose) {
        this.myChart.dispose(); // 销毁之前的实例
      }
      this.myChart = echarts.init(chartDom);
      // myChart= this.$echarts.init(this.$refs.hoursPrice);
      let option = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  toolbox: {
    feature: {
      // dataView: { show: true, readOnly: false },
      // magicType: { show: true, type: ['line', 'bar'] },
      // restore: { show: true },
      saveAsImage: { show: true }
    }
  },
  legend: {
    data: legend
  },
  xAxis: [
    {
      type: 'category',
      data: xAxis,
      axisPointer: {
        type: 'shadow'
      }
    }
  ],
  yAxis: [
    {
      type: 'value',
     
    }
    
  ],
  series: series
};
      option &&this.myChart.setOption(option);
    },
    showMonthPrice(legend, xAxis, series,type) {
      console.log("legend", legend);
      console.log("xAxis", xAxis);
      console.log("series", series);
       console.log("type", type);
      if (this.myChart != null && this.myChart.dispose) {
        this.myChart.dispose(); // 销毁之前的实例
      }
      const chartDom = this.$refs.hoursPrice;
      this.myChart = echarts.init(chartDom);
      let title1="",tooltipTrigger='',gtext1="",gtext2="",gtext3="",gtext4="";
   
    let tv =  this.ectricityVoltageLevel.find(t=>t.levelCode==this.form1.VoltageLevelSelect);
    let tt1 =  this.electricityType1.find(t=>t.typeCode==this.form1.Type1lSelect);
    let tt2=  this.electricityType2.find(t=>t.typeCode==this.form1.Type2lSelect);
    if(type=="hoursPrice"){
      title1=this.form1.regionSelect + "工商业购电分时电价图";
      tooltipTrigger='item';
      gtext1= this.type1Grapy.text1+"千瓦/月";
      gtext2=  this.type1Grapy.text2+"千伏安/月";
    }
    if(type=="monthPrice"){
      title1=this.form1.regionSelect + "工商业购电分月电价图";
      tooltipTrigger='axis';
      gtext1= this.type2Grapy.text1;
      gtext2=  this.type2Grapy.text2;
     gtext3= this.type2Grapy.text3;
      gtext4= this.type2Grapy.text4;
    }
    if(type=="peakValleyPrice"){
      title1=this.form1.regionSelect + "工商业购电峰谷价差";
      tooltipTrigger='axis';
    }
      let option = {
        tooltip: {
          show: true,
          trigger: tooltipTrigger,
        },
        title: {
          text: title1,
          subtext:tt1.typeName+'-'+tt2.typeName+'-'+tv.levelName,
          textStyle: {
            //主标题
            color: "#3E4956",
            fontWeight: "bold",
            fontSize: 30,
            fontFamily: "Haettenschweiler",
          },
          itemGap: 12, //主副标题之间的距离
          //   top: "1%",
          left: "center",
        },
        legend: {
          bottom: 0,
          data: legend,
        },
        grid: {
          left: "20%",
          right: "5%",
          bottom: "10%",

          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
         graphic: [
          {
            type: "text",
            left: "left",
            top: "120px",
            z: 2,
            zlevel: 100,
            style: {
              text: gtext2,
              fill: "#000000",             
              font: "bold 14px Microsoft YaHei"
            }
          },
          {
            type: "text",
            left: "left",
            top: "140px",
            z: 2,
            zlevel: 100,
            style: {
              text: gtext1,
              fill: "#000000",
              font: "bold 14px Microsoft YaHei"
            }
          }
        ],
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: xAxis,
          },
        ],
        yAxis: [
          {
            type: "value",
             axisLabel:{
            margin: 0, // 设置标签与坐标轴之间的间距为10像素
          },
          },
         
        ],
        series: series,
      };
      if(gtext1){
        option.graphic[0]={
            type: "text",
            left: "left",
            top: "120px",
            z: 2,
            zlevel: 100,
            style: {
              text: gtext1,
              fill: "#000000",             
              font: "bold 14px Microsoft YaHei"
            }
          }
      }
      if(gtext2){
        option.graphic[1]={
            type: "text",
            left: "left",
            top: "140px",
            z: 2,
            zlevel: 100,
            style: {
              text: gtext2,
              fill: "#000000",             
              font: "bold 14px Microsoft YaHei"
            }
          }
      }
       if(gtext3){
        option.graphic[2]={
            type: "text",
            left: "left",
            top: "160px",
            z: 2,
            zlevel: 100,
            style: {
              text: gtext3,
              fill: "#000000",             
              font: "bold 14px Microsoft YaHei"
            }
          }
      }
       if(gtext4){
        option.graphic[3]={
            type: "text",
            left: "left",
            top: "180px",
            z: 2,
            zlevel: 100,
            style: {
              text: gtext4,
              fill: "#000000",             
              font: "bold 14px Microsoft YaHei"
            }
          }
      }
      option && this.myChart.setOption(option);

    },
    showPeakValleyPrice() {
    },

    getElectricityAnalysis(param) {
      getElectricityAnalysis(param).then((res) => {
        console.log("getElectricityBusiness", res);
        if (res.code == "200") {
          this.showfenxi(res.data.legend.data, res.data.xAxis.data, res.data.series)
        }
      });
    },
    // 工商业电价谷峰价差
    getElectricityBusiness(param) {

      getElectricityBusiness(param).then((res) => {
        console.log("getElectricityBusiness", res);
        if (res.code == "200") {
          console.log("param.searchType",param.searchType)

          // if( param.searchType = "hoursPrice"){
          //   this.showMonthPrice(res.data.legend.data, res.data.xAxis.data, res.data.series,param.searchType)
          // }else{
           if(param.searchType == "hoursPrice"){
          this.type1Grapy.text1 = '需量电价：' + res.data.demandPrice;
          this.type1Grapy.text2 = '容量电价：' + res.data.capacityPrice;
           }
            if(param.searchType == "monthPrice"){
          this.type2Grapy.text4 = '平均低谷电价:'+res.data.offPeakPeriodPriceAverage+'元/度';
          this.type2Grapy.text2 = '平均高峰电价:' + res.data.peakHoursPriceAverage+'元/度';
          this.type2Grapy.text1 = '平均尖峰电价:'+res.data.sharpPeriodPriceAverage+'元/度';
          this.type2Grapy.text3 = '平均平时电价:'+res.data.shoulderPeriodPriceAverage+'元/度';

            }
              this.showMonthPrice(res.data.legend.data, res.data.xAxis.data, res.data.series,param.searchType)
          // }
         // }
          // if( pramas.searchType = "monthPrice"){
        

        }
      });
    },
    getRegion(type = "工商业电价") {
      let param = {
        customerType: type,
        region: "",
      };
      getRegion(param).then((res) => {
        console.log("getRegion", res);
        if (res && res.code == "200") {
          this.region = res.data;
          this.form1.regionSelect = res.data[0];
        }
      });
    },
    getElectricityType() {
      getElectricityType().then((res) => {
        console.log("getElectricityType", res);
        if (res && res.code == "200") {
          let gyType = res.data.filter((t) => t.typeCode == "business");
          let jmType = res.data.filter((t) => t.typeCode == "residential");
          let type1 = gyType[0].children.filter((t) => t.typeCode == "type1");
          let type2 = gyType[0].children.filter((t) => t.typeCode == "type2");
          console.log(type1[0].children);
          this.electricityType1 = type1[0].children;
          this.electricityType2 = type2[0].children;
        }
      });
    },
    getElectricityVoltageLevel() {
      getElectricityVoltageLevel({ page: 1, limit: 10000 }).then((res) => {
        console.log("getElectricityVoltageLevel", res);
        if (res && res.code == "200") {
          this.ectricityVoltageLevel = res.data;
          this.form1.VoltageLevelSelect = this.form2.VoltageLevelSelect2 =
            this.ectricityVoltageLevel[0].levelCode;
        }
      });
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      if (tab.name == "second") {
        this.$nextTick(() => {
          this.tab2Search();
        });
      }
    },
  },
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
};
</script>

<style lang="scss" scoped>
.china-map {

  width: 62.5vw;
  height: 800px;
  /* 必须指定画布的高度 否则无法渲染 */
}

.containt {
  display: flex;
  //   justify-content: space-between;

  .left {
    width: 20%;
  }

  .right {
    width: 80%;
  }
}

.data_brain_wrap {
  padding: 70px 0;
  background: #e8eef2;
}

.card_wrap {
  width: 80%;
  flex-wrap: wrap;
  margin: 0px auto;
  justify-content: space-between;
  //   height: 2400px;
  border-radius: 8px;
  position: relative;

  @media screen and (max-width: 768px) {
    width: 95%;
  }

  .el-tabs {
    width: 100%;
  }
}
</style>
